import { render, staticRenderFns } from "./QuoteAttachmentCategory.vue?vue&type=template&id=50dd8e4d"
import script from "./QuoteAttachmentCategory.vue?vue&type=script&lang=js"
export * from "./QuoteAttachmentCategory.vue?vue&type=script&lang=js"
import style0 from "./QuoteAttachmentCategory.vue?vue&type=style&index=0&id=50dd8e4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports